<script>
  import * as api from '@/services/api.js'
  import { rules } from 'eslint-config-prettier'
  export default {
    name: 'authCard',
    data: () => ({
      // authCode: '',
      // authCode: 'TN4KE3BCJEAAS3',
      isLoading: false,
      formValid: true,
      message: null,
      // password: 'Newyork12434',
      password: null,
      showPassword: false,
      username: null,
      // username: 'emeraldgreen3@egtnyc.com',
      // authCode: null,

      ////
      passRules: [
        v => !!v || 'Password is required'
        // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      userRules: [v => !!v || 'E-mail is required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid']
    }),
    computed: {
      // codeInput: {
      //   get() {
      //     return this.authCode
      //   },
      //   set(v) {
      //     this.authCode = v.toUpperCase()
      //   },
      // },
    },
    methods: {
      async onSubmit() {
        // const code = codeIn || this.authCode
        this.message = null
        this.isLoading = true
        // using login now
        // if (!code) {
        //   this.message = 'Authorization code required.'
        //   this.isLoading = false
        //   return
        // }

        // this.message = this.message ? null : 'Test message here'
        const resp = await api.post('auth/login', { password: this.password, username: this.username }).catch(e => {
          console.log(e)
          this.message = 'Error connecting to backend service..'
          this.isLoading = false
          return false
        })
        // console.log(resp)
        const isAuth = resp?.status === 'ok'
        if (!isAuth) {
          this.message = 'Invalid credentials entered.'
          this.isLoading = false
        } else {
          this.$store.dispatch('setIsAuth', true)
          //TODO: DE-DUPLICATE CODE IN HOMEVIEW  COMP
          this.$store.dispatch('setActiveAccount', resp.account)
          this.$store.dispatch('setActiveAccountTrailers', resp.trailers)
          if (resp?.trailerMap) {
            this.$store.dispatch('setTrailerMap', resp.trailerMap)
          }
          // console.log('TODO add to saved accounts')
          // this.$store.dispatch('setActiveAccountSession', tokenData)
          this.$router.push('/')
        }
      }
    }
  }
</script>
<template>
  <v-card width="100%" max-width="460" class="login-card">
    <v-card-title class="primary--text justify-center text-h4">WELCOME</v-card-title>
    <v-card-text class="card-text d-flex flex-column justify-space-around">
      <v-form v-model="formValid" id="login-form" @submit.prevent="onSubmit">
        <!-- Please confirm access. -->
        <v-text-field
          v-model="username"
          color="primary"
          id="username"
          label="Username"
          outlined
          required
          :rules="userRules"
          type="email"
          :validate-on-blur="!password"
          class="mt-4"
        ></v-text-field>
        <v-text-field
          v-model="password"
          color="primary"
          full-width
          id="password"
          :append-icon="!showPassword ? 'mdi mdi-eye' : 'mdi mdi-eye-off'"
          label="Password"
          outlined
          required
          :rules="passRules"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
          class="mt-4"
        ></v-text-field>
        <!-- @keyup.enter="onSubmit(codeInput)" -->
        <p v-if="message" v-html="message" class="error--text"></p>
        <v-btn block color="primary" :disabled="!formValid" large :loading="isLoading" type="submit" role="submit" class="mt-8"> submit </v-btn>
        <!-- @click="onSubmit(codeInput)" -->
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .login-card {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #authinput {
    text-align: center;
  }

  >>> .v-input input {
    /* text-align: center; */
    color: var(--primary-text);
    font-size: 2rem;
  }
</style>
